import { load } from "@cashfreepayments/cashfree-js";
import {
  BasketIcon,
  Divider,
  GKButton,
  Grid2,
  ResetIcon,
  RupeeIcon,
  RupeeIcon1,
  StatusField,
  Typography,
} from "components";
import useEnvironmentCheck from "hooks/useEnvironmentCheck";
import { useMutation } from "hooks/useQueries";
import { isEmpty } from "lodash";
import { RightArrowIcon } from "Pages/Website/Icons";
import { useEffect, useState } from "react";
import { useFormContext } from "react-hook-form";
import { useLocation } from "react-router-dom";
import { useAppSelector } from "store/store";
import { numberToCurrency } from "utils";
import axiosInstance from "utils/axiosInstance";
import { handleReturnAmount } from "utils/helpers";

const PaymentTab = () => {
  const form = useFormContext();

  const location = useLocation();

  const investorOnBoardflowData = useAppSelector(
    (state) => state?.app?.investorOnBoardflowData,
  );

  const { getLocalEnvironment } = useEnvironmentCheck();

  const skipPayment =
    new URLSearchParams(location.search).get("skip_advance_fee") === "True";

  console.log(skipPayment, "skipPayment");

  const [cashFeeSDK, setCashFreeSDK] = useState(null);

  const initializeSDK = async () => {
    const data = await load({
      mode: getLocalEnvironment ? "sandbox" : "production",
    });
    setCashFreeSDK(data);
  };

  useEffect(() => {
    initializeSDK();
  }, []);

  const { mutate: handlePayment, isLoading } = useMutation({
    mutationKey: ["HANDLE_PAYMENT"],
    mutationFn: (data: any) =>
      axiosInstance.post("/api/revenue/onboarding-flow/", data),
    onSuccess: (response) => {
      if (!isEmpty(response?.data?.data?.paymentLink)) {
        window.location.replace(response?.data?.data?.paymentLink);
      } else {
        cashFeeSDK.subscriptionsCheckout({
          subsSessionId: response?.data?.data?.subscriptionData?.sessionId,
        });
      }
    },
  });

  const checkGst = form.getValues("clientObject.onboardDetails.revenueWithGst");

  return (
    <>
      <Grid2 container size={12}>
        <Grid2 size={7} display={"flex"} flexDirection={"column"} gap={1}>
          <Typography
            fontSize={20}
            fontWeight={600}
            // pt={2}
            sx={{ fontSize: "clamp(1.125rem, 0.6563rem + 1.5vw, 1.5rem)" }}
          >
            {skipPayment ? "Setup Mandate" : "Complete your payment"}
          </Typography>
          <Typography fontSize={12} fontWeight={500} color="var(--neutral-500)">
            Review your payment details and proceed to pay.
          </Typography>
        </Grid2>
        <Grid2
          size={5}
          display={"flex"}
          justifyContent={"flex-end"}
          alignItems={"start"}
        >
          <img
            src="/Logos/iconFullLogo.png"
            alt="GridKey Logo"
            style={{
              height: "32px",
              width: "auto",
            }}
          />
        </Grid2>
        <Grid2 container size={12} mt={3}>
          {/* <Grid2
          // size={{ md: isCashFee ? 8 : 5.9, xs: 12 }}
          size={7}
          m={"auto"}
          textAlign={"center"}
          borderRadius="16px"
          border={"1px solid #E3E8EF"}
        >
          <Grid2
            size={12}
            container
            spacing={1}
            sx={{ p: { xs: 2, md: 5 } }}
            bgcolor={"#F8FAFC"}
          >
            <Grid2
              size={12}
              container
              spacing={1}
              display={"flex"}
              alignItems={"center"}
            >
              <Grid2 size={{ md: 8, xs: 12 }}>
                <Typography
                  fontWeight={500}
                  color="#9AA4B2"
                  display={"flex"}
                  sx={{ fontSize: "clamp(0.875rem, 0.7188rem + 0.5vw, 1rem)" }}
                >
                  Your current fee
                </Typography>
                <Typography
                  fontSize={20}
                  fontWeight={600}
                  color="#202939"
                  display={"flex"}
                  alignItems={"center"}
                  gap={0.5}
                >
                  {numberToCurrency(
                    handleReturnAmount({
                      skipAdvanceFee: skipPayment,
                      feePlanDetails: form.getValues(
                        "clientObject.advanceFeePlan.feePlan",
                      ),
                      advanceFeePlan: form.getValues(
                        "clientObject.advanceFeePlan",
                      ),
                      planDataObject: {
                        holdingsValue: form
                          .getValues("planDataObject.plansHoldings")
                          .map(
                            (d: { cmp: string; quantity: string }) =>
                              +d.cmp * +d.quantity,
                          ),
                        aumCash: form.getValues("planDataObject.aumCash"),
                      },
                      isExitGST: checkGst,
                    }),
                  )}
                  {checkGst && (
                    <Typography fontSize={12} color="#94A3B8">
                      (inclusive of GST)
                    </Typography>
                  )}
                </Typography>
              </Grid2>
              <Grid2
                size={{ md: 4, xs: 12 }}
                display={"flex"}
                justifyContent={{ md: "flex-end", xs: "center" }}
              >
                {investorOnBoardflowData?.paymentMethods !== "manual_payment" &&
                  !form.getValues("clientObject.payment") && (
                    <GKButton
                      variant="contained"
                      disabled={isLoading}
                      onClick={() => {
                        handlePayment({
                          isSendEmail: false,
                          client: form.getValues("clientObject.id"),
                          basket: form.getValues("clientObject.basket.id"),
                          feePlan: form.getValues("selectedFeePlan.id"),
                          portfolio: form.getValues(
                            "clientObject.portfolio.id",
                          ),
                          frequency: skipPayment
                            ? "Quarterly"
                            : form.getValues(
                                "clientObject.advanceFeePlan.frequency",
                              ),
                          advanceFeePlan: skipPayment
                            ? null
                            : form.getValues(
                                "clientObject.advanceFeePlan.feePlan.id",
                              ),
                          flowType: "Client Initiated Advisory Flow",
                        });
                      }}
                    >
                      {skipPayment ? "Setup" : "Pay Now"}
                    </GKButton>
                  )}
                {form.getValues("clientObject.payment") && (
                  <StatusField
                    statusString="paid"
                    styles={{ textTransform: "uppercase" }}
                  />
                )}
              </Grid2>
            </Grid2>
          </Grid2>
          <Grid2 size={12}>
            <Divider />
          </Grid2>
          <Grid2 size={12} container spacing={2} sx={{ p: { xs: 2, md: 5 } }}>
            <Grid2 size={12} container spacing={2}>
              <Grid2 size={{ md: 6, xs: 12 }} textAlign={"start"}>
                <Typography
                  fontWeight={400}
                  color="#64748B"
                  sx={{
                    fontSize: "clamp(0.875rem, 0.5625rem + 1vw, 1.125rem)",
                  }}
                  display={"flex"}
                  alignItems={"center"}
                  gap={0.5}
                >
                  <BasketIcon width={20} /> Basket
                </Typography>
                <Typography
                  fontWeight={500}
                  sx={{
                    fontSize: "clamp(0.875rem, 0.5625rem + 1vw, 1.125rem)",
                  }}
                >
                  {form.getValues("clientObject.basket.name") || "-"}
                </Typography>
              </Grid2>
              <Grid2 size={{ md: 6, xs: 12 }} textAlign={"start"}>
                <Typography
                  sx={{
                    fontSize: "clamp(0.875rem, 0.5625rem + 1vw, 1.125rem)",
                  }}
                  fontWeight={400}
                  color="#64748B"
                  display={"flex"}
                  alignItems={"center"}
                  gap={0.5}
                >
                  <Calendar1Icon width={20} height={20} /> Renews every
                </Typography>
                <Typography
                  fontWeight={500}
                  sx={{
                    fontSize: "clamp(0.875rem, 0.5625rem + 1vw, 1.125rem)",
                  }}
                >
                  {skipPayment
                    ? "QUARTERLY"
                    : form.getValues("clientObject.advanceFeePlan.frequency") ||
                      "-"}
                </Typography>
              </Grid2>
            </Grid2>
          </Grid2>
        </Grid2>
        {/* <Show.When isTrue={!isCashFee}>
          <Grid2 size={{ md: 0.2, xs: 12 }} textAlign={"center"}>
            <Divider orientation="vertical" />
          </Grid2>
        </Show.When>
        <Show.When isTrue={isCashFee}>
          <Grid2 size={{ md: 5.9, xs: 12 }} textAlign={"center"}>
            <Grid2 container spacing={2}>
              <Grid2 size={12} textAlign={"center"}>
                <Typography
                  fontSize={14}
                  fontWeight={600}
                  color={"var(--black)"}
                  textAlign={"left"}
                >
                  1. Scan the QR Code & Save Your Payment Proof
                </Typography>
                <Typography
                  fontSize={12}
                  fontWeight={500}
                  color={"var(--neutral-500)"}
                  textAlign={"left"}
                >
                  Use your preferred UPI app or payment platform to scan the QR
                  code and complete the payment.
                </Typography>
                <img
                  src={""}
                  style={{ width: "40%", height: "auto", marginTop: 8 }}
                  alt=""
                />
              </Grid2>
              <Grid2 size={12}>
                <Divider />
              </Grid2>
              <Grid2 size={12}>
                <Typography
                  fontSize={14}
                  fontWeight={600}
                  color={"var(--black)"}
                  textAlign={"left"}
                >
                  2. Upload Payment Proof
                </Typography>
                <Typography
                  fontSize={12}
                  fontWeight={500}
                  color={"var(--neutral-500)"}
                  mb={2}
                  textAlign={"left"}
                >
                  Upload the saved payment proof using the upload section
                  located beside the QR code.
                </Typography>
                <DragDrop
                  value={form.getValues("paymentUpload") || []}
                  supportName="png, jpeg, jpg"
                  setUploadError={setUploadError}
                  uploadError={uploadError}
                  acceptType={".png, .jpeg, .jpg"}
                  onChange={(e) => {
                    form.setValue("paymentUpload", e);
                  }}
                />
              </Grid2>
            </Grid2>
          </Grid2>
        </Show.When> */}
          <Grid2 container size={12} mt={2.5}>
            <Grid2 size={10}>
              <Typography
                fontSize={12}
                fontWeight={500}
                color="var(--neutral-500)"
              >
                Payment Amount
              </Typography>
              <Typography
                fontSize={24}
                fontWeight={600}
                color="var(--grey-900)"
                display={"flex"}
                alignItems={"center"}
                gap={0.5}
              >
                {numberToCurrency(
                  handleReturnAmount({
                    skipAdvanceFee: skipPayment,
                    feePlanDetails: form.getValues(
                      "clientObject.advanceFeePlan.feePlan",
                    ),
                    advanceFeePlan: form.getValues(
                      "clientObject.advanceFeePlan",
                    ),
                    planDataObject: {
                      holdingsValue: form
                        .getValues("planDataObject.plansHoldings")
                        .map(
                          (d: { cmp: string; quantity: string }) =>
                            +d.cmp * +d.quantity,
                        ),
                      aumCash: form.getValues("planDataObject.aumCash"),
                    },
                    isExitGST: checkGst,
                  }),
                )}
              </Typography>
              {checkGst && (
                <Typography
                  fontSize={10}
                  fontWeight={400}
                  color="var(--neutral-500)"
                >
                  (including GST)
                </Typography>
              )}
            </Grid2>
            <Grid2 size={2} display={"flex"} justifyContent={"flex-end"}>
              <RupeeIcon1 />
            </Grid2>
          </Grid2>
          <Grid2 container size={12} mt={3}>
            <Grid2 size={12} gap={1} display="flex" alignItems="center" py={1}>
              <BasketIcon color="var(--grey-500)" />
              <Typography
                sx={{ width: "96px" }}
                fontSize={12}
                fontWeight={500}
                color="var(--grey-500)"
              >
                Basket Name:
              </Typography>
              <Typography
                fontSize={12}
                fontWeight={600}
                color="var(--neutral-700)"
              >
                {form.getValues("clientObject.basket.name") || "-"}
              </Typography>
            </Grid2>
            <Grid2 size={12} py={0.5}>
              <Divider sx={{ borderStyle: "dashed", borderColor: "#ccc" }} />
            </Grid2>
          </Grid2>
          <Grid2 container size={12}>
            <Grid2 size={12} gap={1} display="flex" alignItems="center" py={1}>
              <ResetIcon color="var(--grey-500)" />
              <Typography
                sx={{ width: "96px" }}
                fontSize={12}
                fontWeight={500}
                color="var(--grey-500)"
              >
                Billing Cycle:
              </Typography>
              <Typography
                fontSize={12}
                fontWeight={600}
                color="var(--neutral-700)"
              >
                {skipPayment
                  ? "QUARTERLY"
                  : form.getValues("clientObject.advanceFeePlan.frequency") ||
                    "-"}
              </Typography>
            </Grid2>
            <Grid2 size={12} py={0.5}>
              <Divider sx={{ borderStyle: "dashed", borderColor: "#ccc" }} />
            </Grid2>
          </Grid2>
          <Grid2 container size={12}>
            <Grid2 size={12} gap={1} display="flex" alignItems="center" py={1}>
              <RupeeIcon color="var(--grey-500)" />
              <Typography
                sx={{ width: "96px" }}
                fontSize={12}
                fontWeight={500}
                color="var(--grey-500)"
              >
                Fee Type:
              </Typography>
              <Typography
                fontSize={12}
                fontWeight={600}
                color="var(--neutral-700)"
              >
                {form.getValues(
                  "clientObject.advanceFeePlan.feePlan.managementFee.feeType",
                ) || "-"}
              </Typography>
            </Grid2>
          </Grid2>
        </Grid2>
        <Grid2
          size={12}
          p={2}
          mt={3}
          display={"flex"}
          flexDirection={"column"}
          alignItems={"flex-end"}
          bgcolor={"#F8F8F8"}
          borderRadius={1}
        >
          {/* Gross Fees */}
          <Grid2
            display={"flex"}
            justifyContent={"flex-end"}
            alignItems={"center"}
            gap={1}
            mb={1.5}
          >
            <Typography fontSize={12} fontWeight={400} color="var(--black-900)">
              Gross Fees:
            </Typography>
            <Typography
              fontSize={12}
              fontWeight={600}
              color="var(--grey-900)"
              width={"100px"}
              textAlign={"right"}
            >
              {numberToCurrency(
                checkGst
                  ? handleReturnAmount({
                      skipAdvanceFee: skipPayment,
                      feePlanDetails: form.getValues(
                        "clientObject.advanceFeePlan.feePlan",
                      ),
                      advanceFeePlan: form.getValues(
                        "clientObject.advanceFeePlan",
                      ),
                      planDataObject: {
                        holdingsValue: form
                          .getValues("planDataObject.plansHoldings")
                          .map(
                            (d: { cmp: string; quantity: string }) =>
                              +d.cmp * +d.quantity,
                          ),
                        aumCash: form.getValues("planDataObject.aumCash"),
                      },
                      isExitGST: false,
                    })
                  : handleReturnAmount({
                      skipAdvanceFee: skipPayment,
                      feePlanDetails: form.getValues(
                        "clientObject.advanceFeePlan.feePlan",
                      ),
                      advanceFeePlan: form.getValues(
                        "clientObject.advanceFeePlan",
                      ),
                      planDataObject: {
                        holdingsValue: form
                          .getValues("planDataObject.plansHoldings")
                          .map(
                            (d: { cmp: string; quantity: string }) =>
                              +d.cmp * +d.quantity,
                          ),
                        aumCash: form.getValues("planDataObject.aumCash"),
                      },
                      isExitGST: checkGst,
                    }),
              )}
            </Typography>
          </Grid2>

          {/* GST */}
          <Grid2
            display={"flex"}
            justifyContent={"flex-end"}
            alignItems={"center"}
            gap={1}
            mb={1.5}
          >
            <Typography fontSize={12} fontWeight={400} color="var(--black-900)">
              GST (18%):
            </Typography>
            <Typography
              fontSize={12}
              fontWeight={600}
              color="var(--grey-900)"
              width={"100px"}
              textAlign={"right"}
            >
              {checkGst
                ? numberToCurrency(
                    handleReturnAmount({
                      skipAdvanceFee: skipPayment,
                      feePlanDetails: form.getValues(
                        "clientObject.advanceFeePlan.feePlan",
                      ),
                      advanceFeePlan: form.getValues(
                        "clientObject.advanceFeePlan",
                      ),
                      planDataObject: {
                        holdingsValue: form
                          .getValues("planDataObject.plansHoldings")
                          .map(
                            (d: { cmp: string; quantity: string }) =>
                              +d.cmp * +d.quantity,
                          ),
                        aumCash: form.getValues("planDataObject.aumCash"),
                      },
                      isExitGST: false,
                    }) * 0.18,
                  )
                : "₹0.00"}
            </Typography>
          </Grid2>

          {/* Divider */}
          <Divider sx={{ width: "100%", borderStyle: "dashed", mb: 1.5 }} />

          {/* Taxable Value */}
          <Grid2
            display={"flex"}
            justifyContent={"flex-end"}
            alignItems={"center"}
            gap={1}
          >
            <Typography fontSize={14} fontWeight={500} color="var(--black-900)">
              Taxable Value:
            </Typography>
            <Typography
              fontStyle={"italic"}
              fontSize={16}
              fontWeight={600}
              color="var(--black-900)"
              width={"100px"}
              textAlign={"right"}
            >
              {numberToCurrency(
                handleReturnAmount({
                  skipAdvanceFee: skipPayment,
                  feePlanDetails: form.getValues(
                    "clientObject.advanceFeePlan.feePlan",
                  ),
                  advanceFeePlan: form.getValues("clientObject.advanceFeePlan"),
                  planDataObject: {
                    holdingsValue: form
                      .getValues("planDataObject.plansHoldings")
                      .map(
                        (d: { cmp: string; quantity: string }) =>
                          +d.cmp * +d.quantity,
                      ),
                    aumCash: form.getValues("planDataObject.aumCash"),
                  },
                  isExitGST: checkGst,
                }),
              )}
            </Typography>
          </Grid2>
        </Grid2>
        <Grid2
          size={12}
          mt={3}
          display={"flex"}
          justifyContent={{ xs: "center", md: "flex-end" }}
        >
          {investorOnBoardflowData?.paymentMethods !== "manual_payment" &&
            !form.getValues("clientObject.payment") && (
              <GKButton
                startIcon={<RupeeIcon />}
                endIcon={<RightArrowIcon />}
                variant="contained"
                disabled={isLoading}
                sx={{ width: { xs: "100%", md: "auto" } }}
                onClick={() => {
                  handlePayment({
                    isSendEmail: false,
                    client: form.getValues("clientObject.id"),
                    basket: form.getValues("clientObject.basket.id"),
                    feePlan: form.getValues("selectedFeePlan.id"),
                    portfolio: form.getValues("clientObject.portfolio.id"),
                    frequency: skipPayment
                      ? "Quarterly"
                      : form.getValues("clientObject.advanceFeePlan.frequency"),
                    advanceFeePlan: skipPayment
                      ? null
                      : form.getValues(
                          "clientObject.advanceFeePlan.feePlan.id",
                        ),
                    flowType: "Client Initiated Advisory Flow",
                  });
                }}
              >
                {skipPayment ? "Setup" : "Pay Now"}
              </GKButton>
            )}
          {form.getValues("clientObject.payment") && (
            <StatusField
              statusString="paid"
              styles={{ textTransform: "uppercase" }}
            />
          )}
        </Grid2>
      </Grid2>
    </>
  );
};

export default PaymentTab;
